import React, {useContext} from 'react';
import {observer} from "mobx-react";
import {StoreContext} from "../../../store.context";
import {Space, Table} from "antd";
import {TableRowActions} from "../../base/action/table/table.row.actions";
import {TranslationDomainEnum} from "../../../types/enums";
import {Translate} from "../../../components/util/translation.util";
import type { TablePaginationConfig } from 'antd/es/table';
import type { FilterValue } from 'antd/es/table/interface';
import {OtherCompanyListItem} from "../../../types/modules/otherCompanu/modules";
import {PaginatorTotal} from "../../../components/table/list/paginator.total";

export const FilterTable: React.FC = observer(() => {
    const {
        appStore: {
            moduleStore: {
                otherCompanyStore: {
                    items,
                    list,
                    module,
                    headers,
                    actions,
                    current,
                    pageSize,
                    total,
                    setTablePaginationData,
                    loading
                },
            }
        }
    } = useContext(StoreContext);

    const handleTableChange = (
        pagination: TablePaginationConfig,
        filters: Record<string, FilterValue | null>,
        sorter: any
    ) => {
        setTablePaginationData({
            current: pagination.current,
            pageSize: pagination.pageSize,
            field: sorter.order ? sorter.field : null,
            order: sorter.order ? sorter.order : null
        });

        list();
    };

    return (
        <Space direction={`vertical`} size={`middle`} style={{ display: 'flex' }}>
            <Table dataSource={items as OtherCompanyListItem[]}
                   size={`small`}
                   onChange={handleTableChange}
                   loading={loading}
                   rowKey={`id`}
                   pagination={{
                       current, pageSize, total, position: ['bottomCenter'], showSizeChanger: true, showTotal: (total: number, range: [number, number]): any => (
                               <PaginatorTotal from={range[0]} to={range[1]} total={total}/>
                       ), locale:{ items_per_page: ""}
                   }}
            >
                { headers.map(header => {

                    if (header === 'disabled') {
                        return (
                                <Table.Column<OtherCompanyListItem>
                                        title={<Translate message={`otherCompany.fields.status`}
                                                          domain={TranslationDomainEnum.COMPANY_ADMINISTRATION}/>}
                                        dataIndex={header}
                                        key={header}
                                        sorter={false}
                                        render={(_) => (
                                                <Translate message={_ ? "global.not_active" : "global.active"}/>
                                        )}
                                />
                        )
                    }

                    if (header === 'phone') {
                        return (
                                <Table.Column<OtherCompanyListItem>
                                        title={<Translate message={`companyContactData.fields.phone`} domain={TranslationDomainEnum.COMPANY_ADMINISTRATION} />}
                                        dataIndex={header}
                                        key={header}
                                        sorter={false}
                                />
                        )
                    }

                    if (header === 'email') {
                        return (
                                <Table.Column<OtherCompanyListItem>
                                        title={<Translate message={`companyContactData.fields.email`} domain={TranslationDomainEnum.COMPANY_ADMINISTRATION} />}
                                        dataIndex={header}
                                        key={header}
                                        sorter={false}
                                />
                        )
                    }

                    if (header === 'iban') {
                        return (
                                <Table.Column<OtherCompanyListItem>
                                        title={<Translate message={`companyBankData.fields.iban`} domain={TranslationDomainEnum.COMPANY_ADMINISTRATION} />}
                                        dataIndex={header}
                                        key={header}
                                        sorter={false}
                                />
                        )
                    }


                    return (
                        <Table.Column<OtherCompanyListItem>
                            title={<Translate message={`otherCompany.fields.${header}`} domain={TranslationDomainEnum.COMPANY_ADMINISTRATION} />}
                            dataIndex={header}
                            key={header}
                            sorter={header !== 'addressString'}
                        />
                    )
                })}
                <Table.Column<OtherCompanyListItem> title={<Translate message={`global.actions`} domain={TranslationDomainEnum.MESSAGES} />} dataIndex={`actions`} key={`actions`} align={`right`}
                    render={(_, record) => <TableRowActions module={ module } record={ record } actions={ actions } />}
                />
            </Table>
        </Space>
    )
})